var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuariosInternos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 175V158.333C50 149.493 53.5119 141.014 59.7631 134.763C66.0143 128.512 74.4928 125 83.3333 125H116.667C125.507 125 133.986 128.512 140.237 134.763C146.488 141.014 150 149.493 150 158.333V175M66.6667 58.3333C66.6667 67.1739 70.1786 75.6523 76.4298 81.9036C82.681 88.1548 91.1594 91.6667 100 91.6667C108.841 91.6667 117.319 88.1548 123.57 81.9036C129.821 75.6523 133.333 67.1739 133.333 58.3333C133.333 49.4928 129.821 41.0143 123.57 34.7631C117.319 28.5119 108.841 25 100 25C91.1594 25 82.681 28.5119 76.4298 34.7631C70.1786 41.0143 66.6667 49.4928 66.6667 58.3333Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuariosInternos);
export default __webpack_public_path__ + "static/media/UsuariosInternos.6833ffd629f445415c1e0235111ff950.svg";
export { ForwardRef as ReactComponent };